export default "__VITE_ASSET__BtH$yWwq__"